<script setup>
import TripFinderRefine from './TripFinderRefine.vue'

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  open: {
    type: Boolean,
    default: false,
  },
  mode: {
    type: String,
    default: 'build',
  },
  scope: {
    type: String,
    default: 'local',
  }
})

const emit = defineEmits(['update:open', 'search'])
</script>

<template>
  <div class="tripfinder-mobile-refine-panel mb-10">
    <TripFinderRefine
      :disabled="disabled"
      :open="open"
      :mode="mode"
      :scope="scope"
      @update:open="emit('update:open', $event)"
      @search="emit('search')"
    />
  </div>
</template>
